import API from '@/network/API'
import { CustomSuccessData } from 'axios'
import GuestRestaurantInfo from '../models/GuestRestaurantInfo'

const _baseUrl = 'restaurants/v1.0'

// 获取餐厅详情
async function fetchRestaurantDetailInfo(
  shopId: string
): Promise<CustomSuccessData<GuestRestaurantInfo>> {
  return API.instance().get<GuestRestaurantInfo>(
    `${_baseUrl}/${shopId}/restaurantDetailInfo`
  )
}

// 用户领取优惠券
async function userFetchGiftCoupon(
  shopId: string,
  giftCouponId: string,
  channelId?: string
): Promise<CustomSuccessData<void>> {
  return API.instance().post<void>(
    `${_baseUrl}/users/restaurants/${shopId}/giftCoupons`,
    { giftCouponId, channelId }
  )
}

// 收藏餐厅
async function favoriteRestaurants(
  restaurantId: string
): Promise<CustomSuccessData<void>> {
  return API.instance().put<void>('/user/v1.0/favoriteRestaurants', {
    restaurantId
  })
}

// 取消收藏餐厅
async function deleteFavoriteRestaurant(
  restaurantId: string
): Promise<CustomSuccessData<void>> {
  return API.instance().delete<void>(
    `/user/v1.0/favoriteRestaurants/${restaurantId}`
  )
}

export {
  fetchRestaurantDetailInfo,
  userFetchGiftCoupon,
  favoriteRestaurants,
  deleteFavoriteRestaurant
}
